import axios from 'axios'

// export const host = 'http://159.89.210.156:7000'
export const url = process.env.VUE_APP_API_URL
export const port = process.env.VUE_APP_API_PORT
export const host = url + ':' + port + '/api/vMonk/'
export const hostUrl = url + ':' + port
export const hostImageUrl = url + '/api/vMonk/reqEmployee/img/'
export const hostImageUrlv2 = url + '/api/vMonk/reqEmployee/imgV2'
export const hostImageUrlv3 = url + ':' + port + '/api/vMonk/reqEmployee/imgV2'

export const ManageOrg = axios.create({
  baseURL: host,
  timeout: 60000,
  headers: {}
})
// API Login
export const loginWithAuth = async (data) => {
  try {
    const response = await ManageOrg.post('login', data)
    return response.data
  } catch (error) {
    console.warn('Error Login User :', error.response)
  }
}
// Login role guest
export const loginGuestWithAuth = async (data) => {
  try {
    const response = await ManageOrg.post('login/guest', data)
    return response.data
  } catch (error) {
    console.warn('Error Login User Guest :', error.response)
  }
}
// get data user
export const getUserAuth = async (token, data) => {
  try {
    const response = await ManageOrg.post('users/getDetailUserByToken', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get User Data :', error.response)
  }
}
// จัดการพนักงาน เลือกศูนย์ในแก้ไขพนักงาน และ เพิ่มพนักงาน
export const SelectDataCenterinEditOfficer = async (token) => {
  try {
    const response = await ManageOrg.get('manageEmployee/setect', {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error manageEmployee/setect :', error.response)
  }
}
// get data dashboard
export const fetchDashboardByCompanyId = async (token, data) => {
  try {
    // const response = await ManageOrg.post('dashboard/viewDashboardByCompanyIdV2', data, {
    const response = await ManageOrg.post('dashboard/viewDashboardByRole', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Fetch Dashboard:', error.response)
  }
}
export const getMemberFilter = async (data, token) => {
  try {
    const response = await ManageOrg.get('managementCenter/selectMemberOrgChart/' + data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Data Member Filter:', error.response)
  }
}

export const getLeaderLsit = async (data, token) => {
  try {
    const response = await ManageOrg.post('orgChart/getUserInChartById', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Data Employee Position:', error.response)
  }
}
export const getMemberLsit = async (data, token) => {
  try {
    const response = await ManageOrg.post('managementCenter/getMemberOrgChart', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Data Employee Member:', error.response)
  }
}
export const updateSecLeader = async (data, token) => {
  try {
    const response = await ManageOrg.post('orgChart/updateSecondaryLeader', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Update Secondary Leader Member:', error.response)
  }
}

export const getLineWork = async (token, data) => {
  try {
    const response = await ManageOrg.post('managementCenter/getOverviewMng_V2', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get Line Work :', error.response)
  }
}

export const getSelectLineWork = async (token) => {
  try {
    const response = await ManageOrg.get('managementCenter/getSelectMng_V2', {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get Select Line Work :', error.response)
  }
}

export const getSelectCompany = async (token) => {
  try {
    const response = await ManageOrg.get('orgChart/getSelectCompanies', {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get Select Company :', error.response)
  }
}

export const getSelectCompanyByUser = async (token) => {
  try {
    const response = await ManageOrg.get('users/selectCompaniesByToken', {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get Select Company :', error.response)
  }
}

export const getSelectCompanyHeader = async (data, token) => {
  try {
    const response = await ManageOrg.post('orgChart/SelectPNodeByTypeAndCompId', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get Select Company Header :', error.response)
  }
}

export const getUserByKeyword = async (data, token) => {
  try {
    const response = await ManageOrg.post('users/searchUser', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get User By Keyword :', error.response)
  }
}

// ข้อมูล user ลงทะเบียน
export const getUserByLogin = async (data, token) => {
  try {
    const response = await ManageOrg.post('selector/users', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get User By Keyword :', error.response)
  }
}
// ข้อมูล user จัดการพนักงาน
export const getUserByEmployee = async (data, token) => {
  try {
    const response = await ManageOrg.post('selector/users/employee', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get User By Keyword :', error.response)
  }
}
export const addOrgChartByNode = async (data, token) => {
  try {
    const response = await ManageOrg.post('orgChart/insertOrgChart', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Insert Org Chart :', error.response)
  }
}

export const addOrgChartByNodeV2 = async (data, token) => {
  try {
    const response = await ManageOrg.post('orgChart/insertOrgChartV2', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Insert Org Chart :', error.response)
  }
}

export const fetchMainOrgchart = async (data, token) => {
  try {
    const response = await ManageOrg.post('orgChart/orgchartGroup', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Fetch Main Org Chart :', error.response)
  }
}

export const fetchViewOrgchart = async (token, data) => {
  try {
    const response = await ManageOrg.post('orgChart/orgchart', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Fetch View Org Chart :', error.response)
  }
}

export const fetchMainOrgchartNoCutText = async (data, token) => {
  try {
    const response = await ManageOrg.post('orgChart/viewGropChart', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Fetch Main Org Chart :', error.response)
  }
}

export const fetchViewOrgchartNoCutText = async (token, data) => {
  try {
    const response = await ManageOrg.post('orgChart/viewOrgchart', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Fetch View Org Chart :', error.response)
  }
}

export const generateBase64Image = async (token, data) => {
  try {
    const response = await ManageOrg.post('orgChart/getBase64ByPart', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Generate Base64 Image :', error.response)
  }
}

export const updateOrgChartByNode = async (data, token) => {
  try {
    const response = await ManageOrg.post('orgChart/editOrgChart', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Update Org Chart :', error.response)
  }
}

export const updateOrgChart = async (data, token) => {
  try {
    const response = await ManageOrg.post('orgChart/editOrgChartV2', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Update Org Chart :', error.response)
  }
}

export const deleteOrgChartById = async (token, data) => {
  try {
    const response = await ManageOrg.post('orgChart/deleteOrgChartId', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Delete Org Chart :', error.response)
  }
}

export const getOrgChartById = async (data, token) => {
  try {
    const response = await ManageOrg.post('orgChart/getChartById', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get Org Chart By ID :', error.response)
  }
}

export const getOrgChartData = async (data, token) => {
  try {
    const response = await ManageOrg.get('orgChart/getOrgChartData/' + data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get Org Chart Data :', error.response)
  }
}

// Manage Company
export const insertCompany = async (data, token) => {
  try {
    const response = await ManageOrg.post('companys/createCompany', data, {
      // const response = await ManageOrg.post('reqEmployee/insertReqEmployee', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Insert Company :', error.response)
    return error.response
  }
}
// api showLevel หน้าตาราง
export const getDataStructure = async (data) => {
  try {
    const response = await ManageOrg.post('orgStructureLevel/showLevel', data)
    return response.data
  } catch (error) {
    console.warn('Error Get Data Structure :', error.response)
  }
}

// api changeLevel (ถัดไป,แก้ไข)
export const getChangeLevel = async (data) => {
  try {
    const response = await ManageOrg.post('orgStructureLevel/changeLevel', data)
    return response.data
  } catch (error) {
    console.warn('Error Get Change and Edit Level :', error.response)
  }
}

// api createLevel (สร้างโครงสร้าง)
export const createLevel = async (data, token) => {
  try {
    const response = await ManageOrg.post('orgStructureLevel/createLevel', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Create Level :', error.response)
  }
}
// api editLevel (แก้ไขโครงสร้าง)
export const editLevel = async (data, token) => {
  try {
    const response = await ManageOrg.post('orgStructureLevel/editLevel', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Edit Level :', error.response)
  }
}
// api selectdataStructure (ตัวเลือกค้นหาโครงสร้าง)
export const selectStructure = async (data, token) => {
  try {
    const response = await ManageOrg.post('orgStructureLevel/selector', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get Select :', error.response)
  }
}

// ตัวเลือก
export const selectLevelStructure = async (data) => {
  try {
    const response = await ManageOrg.post('selector/orgStrucLevel', data)
    return response.data
  } catch (error) {
    console.warn('Error Get Level Select :', error.response)
  }
}
// Manage Structure
export const getStructure = async (token, data) => {
  try {
    const response = await ManageOrg.post('managementCenter/getMngstructure', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get Structure :', error.response)
  }
}
export const getStructureV2 = async (token, data) => {
  try {
    const response = await ManageOrg.post('orgChart/overViewChart', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get Structure :', error.response)
  }
}
export const getSelectStructure = async (token, data) => {
  try {
    const response = await ManageOrg.post('managementCenter/selectMngstructure', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get Select Structure :', error.response)
  }
}

// Manage Agency
export const getAgencyList = async (data, token) => {
  try {
    const response = await ManageOrg.post('agency/getAgencyOverview', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get Agency :', error.response)
  }
}

export const getSelectAgency = async (token) => {
  try {
    const response = await ManageOrg.get('agency/getSelectAgency', {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get Select Agency :', error.response)
  }
}

// Manage Work Group
export const getWorkgroupList = async (data, token) => {
  try {
    const response = await ManageOrg.post('groupWork/getGroupWorkOverview', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get Work Group :', error.response)
  }
}

export const getSelectWorkgroup = async (token) => {
  try {
    const response = await ManageOrg.get('groupWork/getSelectGroupWork', {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get Select Work Group :', error.response)
  }
}

// Manage Section
export const getSectionList = async (data, token) => {
  try {
    const response = await ManageOrg.post('section/getSectionOverview', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get Section :', error.response)
  }
}

export const getSelectSection = async (token) => {
  try {
    const response = await ManageOrg.get('section/getSelectSection', {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get Select Section :', error.response)
  }
}

// Manage Department
export const getDepartmentList = async (data, token) => {
  try {
    const response = await ManageOrg.post('department/getDepartmentOverview', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get Department :', error.response)
  }
}

export const getSelectDepartment = async (token) => {
  try {
    const response = await ManageOrg.get('department/getSelectDepartment', {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get Select Department :', error.response)
  }
}

// Manage Position
export const getPositionList = async (data, token) => {
  try {
    const response = await ManageOrg.post('position/positionOverview', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get Position :', error.response)
  }
}

export const getSelectPosition = async (token) => {
  try {
    const response = await ManageOrg.get('position/positionSelect', {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get Select Position :', error.response)
  }
}

export const savePosition = async (data, token) => {
  try {
    const response = await ManageOrg.post('position/insertPosition', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Insert Org Chart :', error.response)
    return error.response
  }
}

export const deletePosition = async (data, token) => {
  try {
    const response = await ManageOrg.post('position/positionDelete', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Delete :', error.response)
  }
}
export const getDetailPosition = async (data, token) => {
  try {
    const response = await ManageOrg.post('position/positionGetUpdateData', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Delete Position :', error.response)
  }
}
export const editPosition = async (data, token) => {
  try {
    const response = await ManageOrg.post('position/positionUpdate', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Update Org Chart :', error.response)
  }
}

export const getSelectPositionAll = async (token) => {
  try {
    const response = await ManageOrg.get('position/positionNameAndLvSelect', {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Search :', error.response)
  }
}
// ตัวเลือกบริษัท แผนก (เมนูใหม่)
export const getSelectPositionAllNew = async (data, token) => {
  try {
    const response = await ManageOrg.post('selector/company/orgchart', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get Data Select :', error.response)
  }
}
// ตัวเลือกบริษัท ตำแหน่ง ระดับตำแหน่ง (เมนูใหม่)
export const getSelectPositionNew = async (data, token) => {
  try {
    const response = await ManageOrg.post('selector/position', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get Data Select :', error.response)
  }
}
// ข้อมูลการจัดการสิทธิ์ (เมนูใหม่)
export const getDataPositionNew = async (data, token) => {
  try {
    const response = await ManageOrg.get(`adminPermission?companyId=${data.companyId}&orgChartId=${data.orgChartId}`, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get Data :', error.response)
  }
}

// เพิ่มข้อมูลจัดการแผนก (เมนูใหม่)
export const AddDataPositionNew = async (data, token) => {
  try {
    const response = await ManageOrg.post('adminPermission', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get Data :', error.response)
  }
}

// ลบข้อมูลสิทธิ์ (เมนูใหม่)
export const deleteDataPositionNew = async (data, token) => {
  try {
    const response = await ManageOrg.delete(`adminPermission?orgChartId=${data}`, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get Data :', error.response)
  }
}

export const uploadFilePosition = async (data, token) => {
  try {
    const response = await ManageOrg.post('position/insertPositionWithFile', data, {
      // const response = await ManageOrg.post('reqEmployee/insertReqEmployee', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Upload File Position :', error.response)
    return error.response
  }
}

// Manage All Request Approve Employee
export const fetchAllRequestApproveEmployee = async (data, token) => {
  try {
    const response = await ManageOrg.post('manageEmployee/getReqEmployeeListByToken', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get All Request Approve Employee :', error.response)
  }
}

// Get Pending Request Approve Employee
export const getPendingRequestApproveEmployee = async (data, token) => {
  try {
    const response = await ManageOrg.post('manageEmployee/getPendingResignList_v2', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.error(error)
    return error.response
  }
}

// Manage Employee
export const uploadFileEmployee = async (data, token) => {
  try {
    const response = await ManageOrg.post('users/insertWithFile', data, {
      // const response = await ManageOrg.post('reqEmployee/insertReqEmployee', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Upload File Employee :', error.response)
    return error.response
  }
}
// API ข้อมูลพนักงาน
// export const getEmployeeList = async (data, token) => {
//   try {
//     const response = await ManageOrg.post('users/getUsers_v3', data, {
//       headers: {
//         Authorization: token
//       }
//     })
//     return response.data
//   } catch (error) {
//     console.warn('Error Get Employee :', error.response)
//   }
// }
export const getEmployeeList = async (data, token) => {
  try {
    const response = await ManageOrg.post('users/getUsers_v6', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get Employee :', error.response)
  }
}

export const getEmployeeListCurrent = async (data, token) => {
  try {
    const response = await ManageOrg.post('manageEmployee/getUsers_current', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get Employee :', error.response)
  }
}

export const getImg = async (userImg, emailOneId, data, token) => {
  try {
    const response = await ManageOrg.get('reqEmployee/imgV2/' + userImg + '/' + emailOneId, data)
    return response.data
  } catch (error) {
    console.warn('Error Get Img :', error.response)
  }
}

export const getEmployeeListApprove = async (data, token) => {
  try {
    const response = await ManageOrg.post('reqEmployee/getReqEmployeeList', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get Employee :', error.response)
  }
}

export const getEmployeeListResign = async (data, token) => {
  try {
    const response = await ManageOrg.post('manageEmployee/getResignList_v2', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get Employee Resign :', error.response)
  }
}
// API get รายชื่อพนักงานตอนค้นหา
export const getSelectEmployee = async (token) => {
  try {
    const response = await ManageOrg.get('users/selectGetUsers_v3', {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get Select Employee :', error.response)
  }
}
// API ค้นหาพนักงาน
export const getUser = async (data, token) => {
  try {
    const response = await ManageOrg.post('users/search/users', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get Select Employee :', error.response)
  }
}

// API จำนวนพนักงาน
export const getNumberEmployee = async (data, token) => {
  try {
    const response = await ManageOrg.post('users/count/employee', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get Select Employee :', error.response)
  }
}
// API get ข้อมูลพนักงานลาออก
export const getSelectEmployeeResign = async (token) => {
  try {
    const response = await ManageOrg.get('manageEmployee/selectResignList', {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get Select Employee :', error.response)
  }
}

export const getSelectEmployeeApprove = async (token) => {
  try {
    const response = await ManageOrg.get('reqEmployee/getSelectReqEmployeeList', {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get Select Employee :', error.response)
  }
}
// ค้นหาข้อมูลพนักงาน
export const searchSelectEmployee = async (data, token) => {
  try {
    const response = await ManageOrg.post('users/searchUserOne', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Search :', error.response)
  }
}

export const searchSelect = async (data, token) => {
  try {
    const response = await ManageOrg.post('orgChart/SelectPNodeByTypeAndCompId', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Search :', error.response)
  }
}

export const searchSelectType = async (data, token) => {
  try {
    const response = await ManageOrg.post('users/getCountDepDataByCompanyId', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Search Type:', error.response)
  }
}
// api get สายงาน ฝ่ายงาน ส่วนงาน
export const checkOrgChartInCompany = async (data, token) => {
  try {
    const response = await ManageOrg.post('manageEmployee/checkOrgChartInCompany', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Search Type:', error.response)
  }
}
// api get ตามสายงานที่เลือกถัดไป
export const getListOrgChart = async (data, token) => {
  try {
    const response = await ManageOrg.post('manageEmployee/getNextOrgChart', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Search Type:', error.response)
  }
}

export const getSelectCompanyEmployeeAll = async (token) => {
  try {
    const response = await ManageOrg.get('orgChart/getSelectCompanies', {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Search :', error.response)
  }
}
// get รายชื่อบริษัทและแผนกตำแหน่ง ใหม่
export const getSelectCompanyEmployeeNew = async (data, token) => {
  try {
    const response = await ManageOrg.post('selector/user/companies', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Search :', error.response)
  }
}
// Company Have Position
export const getSelectCompanyEmployee = async (token) => {
  try {
    const response = await ManageOrg.get('manageEmployee/selectCompanyHavePosition', {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Search :', error.response)
  }
}

export const getSelectCompanyEmployeeDetail = async (data, token) => {
  try {
    const response = await ManageOrg.post('users/selectCompanyByUserId', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Search :', error.response)
  }
}

export const getSelecPositionEmployee = async (token) => {
  try {
    const response = await ManageOrg.get('users/getSelectPosition', {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Search :', error.response)
  }
}
// เพิ่มพนักงาน
export const insertEmployee = async (data, token) => {
  try {
    const response = await ManageOrg.post('manageEmployee/insertReqEmployee', data, {
      // const response = await ManageOrg.post('reqEmployee/insertReqEmployee', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Insert Employee :', error.response)
    return error.response
  }
}
export const editEmployee = async (data, token) => {
  try {
    const response = await ManageOrg.post('manageEmployee/editEmployee', data, {
      // const response = await ManageOrg.post('reqEmployee/insertReqEmployee', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Edit Employee :', error.response)
    return error.response
  }
}
// Update 1st employee detail
export const editEmployeeDetail = async (data, token) => {
  try {
    const response = await ManageOrg.patch('users', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Edit Employee Detail:', error.response)
    return error.response
  }
}

export const getDetailEmployee = async (data, token) => {
  try {
    const response = await ManageOrg.get('users/getDetailUser', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Insert Employee :', error.response)
  }
}
export const getDetailEmployeePosition = async (data, token) => {
  try {
    const response = await ManageOrg.post('users/getPositionforDetailUser', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Data Employee Position:', error.response)
  }
}

export const getlistDetailEmployeePosition = async (data, token) => {
  try {
    const response = await ManageOrg.post('users/getPositionList', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Data Employee Position:', error.response)
  }
}
export const getDetailEmployeeDepartment = async (data, token) => {
  try {
    const response = await ManageOrg.post('users/getDepartmentForDetailUser', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Data Employee Department:', error.response)
  }
}

export const deleteEmployee = async (data, token) => {
  try {
    const response = await ManageOrg.get('manageEmployee/deleteUserData/' + data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Delete :', error.response)
  }
}

export const deleteEmployeeResign = async (data, token) => {
  try {
    const response = await ManageOrg.get('manageEmployee/deleteUserDataForResign/' + data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Delete Resign :', error.response)
  }
}

export const deleteEmployeeDepartment = async (data, token) => {
  try {
    const response = await ManageOrg.post('users/deleteDepDataforDetailUserV2', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Delete :', error.response)
  }
}
export const deleteEmployeePosition = async (data, token) => {
  try {
    const response = await ManageOrg.post('reqEmployee/deleteEmployee', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Delete :', error.response)
  }
}

export const editEmployeeDepartment = async (data, token) => {
  try {
    const response = await ManageOrg.post('users/editDepDataforDetailUserV2', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Edit :', error.response)
  }
}

export const editEmployeePosition = async (data, token) => {
  try {
    const response = await ManageOrg.post('reqEmployee/editPositionDataforDetailUser', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Edit :', error.response)
  }
}

export const searchSelectDetail = async (data, token) => {
  try {
    const response = await ManageOrg.post('users/SelectNodeByType', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Search :', error.response)
  }
}

export const insertEmpDetail = async (data, token) => {
  try {
    const response = await ManageOrg.post('users/insertUserInChart', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Insert Employee :', error.response)
  }
}
// API get ข้อมูลบริษัท
export const getCompanyFilter = async (token) => {
  try {
    const response = await ManageOrg.get('companys/select', {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Data Employee Department:', error.response)
  }
}

export const getDefaultApprover = async (data, token) => {
  try {
    const response = await ManageOrg.post('reqEmployee/getDefaultApprover', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error get default approver :', error.response)
  }
}

export const insertRoleAddOn = async (data, token) => {
  try {
    const response = await ManageOrg.post('users/insertRoleMngAddOn', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Insert Role Add On :', error.response)
    return error.response
  }
}

// Manage Authorityservices
export const getServiceList = async (token) => {
  try {
    const response = await ManageOrg.get('service/selectServiceType', {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Get Service :', error.response)
  }
}

export const searchSelectService = async (data, token) => {
  try {
    const response = await ManageOrg.post('service/selectService', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Search :', error.response)
  }
}

export const insertService = async (data, token) => {
  try {
    const response = await ManageOrg.post('service/createService', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Insert :', error.response)
  }
}

export const editService = async (data, token) => {
  try {
    const response = await ManageOrg.post('service/editService', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Insert :', error.response)
  }
}

// export const deleteService = async (id, token) => {
//   try {
//     const response = await ManageOrg.delete(`service/${id}`, {
//       headers: {
//         Authorization: token
//       }
//     })
//     return response.data
//   } catch (error) {
//     console.warn('Error Insert :', error.response)
//   }
// }

export const deleteService = async (data, token) => {
  try {
    const response = await ManageOrg.post('service/deleteService', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Delete :', error.response)
  }
}

export const getDetailRequest = async (data, token) => {
  try {
    const response = await ManageOrg.post('service/getRequestServiceDetail', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get Detail :', error.response)
  }
}

export const insertRequest = async (data, token) => {
  try {
    const response = await ManageOrg.post('service/insertRequestService', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Insert :', error.response)
  }
}

export const transferApprover = async (data, token) => {
  try {
    const response = await ManageOrg.post('service/updateApprover', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Transfer Approver :', error.response)
  }
}

export const approverService = async (data, token) => {
  try {
    const response = await ManageOrg.post('RA/updateStatusRequestService', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Approver Service :', error.response)
  }
}

export const cancleService = async (data, token) => {
  try {
    const response = await ManageOrg.post('service/cancelRequestService', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Cancle :', error.response)
  }
}
// get data dashboard
export const getListGroupCompanyName = async (token) => {
  try {
    const response = await ManageOrg.get('groupCompany/list', {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get List Group Company Name :', error.response)
  }
}

export const getListCompanyByGroupCompanyEngName = async (token, data) => {
  try {
    const response = await ManageOrg.post('companys/getCompanyByListGroup', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get List Company By Group Company Eng Name :', error.response)
  }
}

export const getAllServiceSetting = async (token, data) => {
  try {
    const response = await ManageOrg.post('service/getAllService', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get All Service Setting :', error.response)
  }
}

export const updateGlobalStatusService = async (token, data) => {
  try {
    const response = await ManageOrg.post('service/updateGlobalService', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Update Global Status Service :', error.response)
  }
}

export const getServiceById = async (token, data) => {
  try {
    const response = await ManageOrg.post('service/getserviceById', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get Service By ID :', error.response)
  }
}

// Role Management
export const getlistDataMenu = async (token) => {
  try {
    const response = await ManageOrg.get('roleManage/getMenuPermissionList', {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Data Menu:', error.response)
  }
}
export const getlistDataMenuById = async (data, token) => {
  try {
    // const response = await ManageOrg.post('roleManage/getRoleManagementForEdit', data, {
    const response = await ManageOrg.get('permission/' + data.id, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Data Menu:', error.response)
  }
}
export const getListRole = async (data, token) => {
  try {
    const response = await ManageOrg.post('permission/permissionSelector', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get List Role:', error.response)
  }
}

export const getWaterfallSelector = async (token) => {
  try {
    const response = await ManageOrg.get('service/waterfallSelector', {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Insert Employee :', error.response)
  }
}

export const getCompanySelector = async (token) => {
  try {
    // const response = await ManageOrg.get('service/seaTheFallenSelector', {
    const response = await ManageOrg.get('companys/selectGroupCompany', {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Insert Employee :', error.response)
  }
}
export const getSelectorGroup = async (token, data) => {
  try {
    const response = await ManageOrg.post('permission/selector', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Select Group :', error.response)
  }
}

export const getChartPickerSelector = async (token, data) => {
  try {
    const response = await ManageOrg.post('service/getPickerOrg', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Insert Employee :', error.response)
  }
}

export const getRoleList = async (data, token) => {
  try {
    const response = await ManageOrg.post('permission/overview', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get Position :', error.response)
  }
}

export const insertRole = async (data, token) => {
  try {
    const response = await ManageOrg.post('permission', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Insert Employee :', error.response)
    return error.response
  }
}

export const editRole = async (data, token) => {
  try {
    const response = await ManageOrg.patch('permission', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Edit :', error.response)
  }
}

export const getSelectRole = async (token) => {
  try {
    const response = await ManageOrg.post('permission/permissionSelector', [], {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get Select Position :', error.response)
  }
}
// Role Company Management
export const getRoleCompanyList = async (data, token) => {
  try {
    const response = await ManageOrg.post('permission/companyOverwiew', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get Position :', error.response)
  }
}
export const getRoleGroupCompanyList = async (data, token) => {
  try {
    // const response = await ManageOrg.post('roleManage/getGroupRoleMngGroupCompany', data, {
    const response = await ManageOrg.post('permission/groupOverview', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get Position :', error.response)
  }
}
export const getRolePersonList = async (data, token) => {
  try {
    const response = await ManageOrg.post('permission/person/overview', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get Position :', error.response)
  }
}
export const getSelectRoleCompany = async (token) => {
  try {
    const response = await ManageOrg.get('permission/selectPermission', {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get Select Position :', error.response)
  }
}
export const deletePermission = async (data, token) => {
  try {
    const response = await ManageOrg.delete('permission/' + data._id, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Delete :', error.response)
  }
}
export const deleteCompanyRole = async (data, token) => {
  try {
    // const response = await ManageOrg.post('roleManage/deleteGroupRoleMng', data, {
    const response = await ManageOrg.delete('permission/company/' + data._id, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Delete:', error.response)
  }
}
export const deleteGroupRole = async (data, token) => {
  try {
    // const response = await ManageOrg.post('roleManage/deleteGroupRoleMng', data, {
    const response = await ManageOrg.delete('permission/group/' + data._id, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Delete:', error.response)
  }
}

export const deletePersonRole = async (data, token) => {
  try {
    // const response = await ManageOrg.post('roleManage/deleteGroupRoleMng', data, {
    const response = await ManageOrg.delete('permission/person/' + data._id, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Delete:', error.response)
  }
}

export const insertRoleCompany = async (data, token) => {
  try {
    // const response = await ManageOrg.post('roleManage/insertGroupRoleMng', data, {
    const response = await ManageOrg.post('permission/company', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Insert Role Company :', error.response)
    return error.response
  }
}
export const updateRoleCompany = async (data, token) => {
  try {
    // const response = await ManageOrg.post('roleManage/insertGroupRoleMng', data, {
    const response = await ManageOrg.patch('permission/company', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Edit Role Company :', error.response)
    return error.response
  }
}
export const insertRoleGroupCompany = async (data, token) => {
  try {
    // const response = await ManageOrg.post('roleManage/insertGroupRoleMng', data, {
    const response = await ManageOrg.post('permission/group', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Insert Role Company :', error.response)
    return error.response
  }
}
export const updateRoleGroupCompany = async (data, token) => {
  try {
    // const response = await ManageOrg.post('roleManage/insertGroupRoleMng', data, {
    const response = await ManageOrg.patch('permission/group', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Insert Role Company :', error.response)
    return error.response
  }
}
export const insertRolePerson = async (data, token) => {
  try {
    const response = await ManageOrg.post('permission/person', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Insert Role Person :', error.response)
    return error.response
  }
}

export const updateRolePerson = async (data, token) => {
  try {
    const response = await ManageOrg.patch('permission/person', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Insert Role Person :', error.response)
    return error.response
  }
}

export const getlistRoleGroupById = async (data, token) => {
  try {
    const response = await ManageOrg.post('permission/group/getPermission', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Data Role Company:', error.response)
  }
}

export const getlistRoleCompanyById = async (data, token) => {
  try {
    const response = await ManageOrg.post('permission/company/getPermission', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Data Role Company:', error.response)
  }
}

export const getlistRolePersonById = async (data, token) => {
  try {
    const response = await ManageOrg.post('permission/person/getPermission', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Data Role Company:', error.response)
  }
}

export const editRoleCompany = async (data, token) => {
  try {
    const response = await ManageOrg.post('roleManage/editGroupRoleMng', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Edit Role Company :', error.response)
    return error.response
  }
}

export const getSelectRoleGroup = async (token) => {
  try {
    const response = await ManageOrg.get('roleManage/selectGroupRoleMngCompany', {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get Select Role Company :', error.response)
  }
}

export const getSelectRoleGroupCompany = async (token) => {
  try {
    const response = await ManageOrg.post('permission/group/selector', null, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get Select Role Company :', error.response)
  }
}

export const getSelectRolePerson = async (token) => {
  try {
    const response = await ManageOrg.post('permission/person/selector', null, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get Select Role Company :', error.response)
  }
}

export const getSelectRoleCompanyList = async (token) => {
  try {
    const response = await ManageOrg.post('permission/company/selector', null, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get Select Role Company :', error.response)
  }
}

export const getMenuPermission = async (token) => {
  try {
    const response = await ManageOrg.post('permission/permissionlistV2', null, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get Select Menu Permission :', error.response)
  }
}

export const checkMenuPermission = async (data, token) => {
  try {
    const response = await ManageOrg.post('permission/checkLink', data, {
      // const response = await ManageOrg.post('roleManage/checkMenuPermission', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error check Menu Permission :', error.response)
  }
}

export const getFirstpage = async (token) => {
  try {
    const response = await ManageOrg.get('permission/firstpage', {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error check Menu Permission :', error.response)
  }
}

export const checkFriendOneChat = async (data, token) => {
  try {
    const response = await ManageOrg.post('service/checkFriendBot', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error check friend one chat bot :', error.response)
  }
}

export const getSelectApproveRequestEmployee = async (data, token) => {
  try {
    const response = await ManageOrg.post('reqEmployee/getSelectApproveRequestEmployee', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error check friend one chat bot :', error.response)
  }
}

export const searchLeader = async (data, token) => {
  try {
    const response = await ManageOrg.post('orgChart/searchLeader', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error searchLeader :', error.response)
  }
}

export const checkDeleteChart = async (data, token) => {
  try {
    const response = await ManageOrg.post('orgChart/checkDeleteChart', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error searchLeader :', error.response)
  }
}

export const getPreViewOrgchart = async (data, token) => {
  try {
    const response = await ManageOrg.post('orgChart/preViewOrgchart', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error searchLeader :', error.response)
  }
}

export const reqEditOrgChart = async (data, token) => {
  try {
    const response = await ManageOrg.post('orgChart/reqEditOrgChartV1', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error reqEditOrgChart :', error.response)
  }
}

export const insertReqEditOrg = async (data, token) => {
  try {
    const response = await ManageOrg.post('orgChart/insertReqEditOrg', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error insertReqEditOrg :', error.response)
  }
}

export const getStructureApproveList = async (data, token) => {
  try {
    const response = await ManageOrg.post('orgChart/getReqOrgChartListByToken', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error getStructureApproveList :', error.response)
  }
}

export const getDetailStructureReq = async (data, token) => {
  try {
    const response = await ManageOrg.post('orgChart/getDetailReqOrgChart', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error getDetailReqOrgChart :', error.response)
  }
}

export const updateStatusStructureReq = async (data, token) => {
  try {
    const response = await ManageOrg.post('orgChart/updateStatusReqOrgChart', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error updateStatusStructureReq :', error.response)
  }
}

export const getselectReqOrgChartList = async (data, token) => {
  try {
    const response = await ManageOrg.post('orgChart/selectReqOrgChartList', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error selectReqOrgChartList :', error.response)
  }
}

export const getGroupCompanyByTokenForChart = async (token) => {
  try {
    const response = await ManageOrg.get('users/selectGroupCompanyByToken', {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error searchLeader :', error.response)
  }
}

// Manage Approve Company and Register
export const insertApproveCompany = async (data, token) => {
  try {
    const response = await ManageOrg.post('companys/createCompanyRequset', data, {
      // const response = await ManageOrg.post('reqEmployee/insertReqEmployee', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Insert Approve Company :', error.response)
    return error.response
  }
}
export const fetchAllRequestApproveCompany = async (data, token) => {
  try {
    const response = await ManageOrg.post('companys/getReqCompanyListByToken', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get All Request Approve Company :', error.response)
  }
}
export const getSelectApproveRequestCompany = async (token) => {
  try {
    const response = await ManageOrg.get('companys/selectCompanyNameInReq', {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error check friend one chat bot :', error.response)
  }
}

export const getGroupRoleList = async (data, token) => {
  try {
    const response = await ManageOrg.post('permission/name', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get All Request Approve Company :', error.response)
  }
}

// export const getRoleFilter = async (data, token) => {
//   try {
//     const response = await ManageOrg.get('permission/name/' + data, {
//       headers: {
//         Authorization: token
//       }
//     })
//     return response.data
//   } catch (error) {
//     console.warn('Error Data Member Filter:', error.response)
//   }
// }

// Manage Approve Business and Register
export const fetchAllRequestManageApproveBusiness = async (data, token) => {
  try {
    // const response = await ManageOrg.post('companys/getReqBusinessListByTokenAndTap', data, { // API เก่า 12/01/66
    const response = await ManageOrg.post('organizeApprove/dashboard', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get All Request Approve Business :', error.response)
  }
}

export const getSelectApproveRequestBusiness = async (data, token) => {
  try {
    const response = await ManageOrg.post('companys/selectReqBusinessList', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error check friend one chat bot :', error.response)
  }
}

// API สร้างธุรกิจ
export const insertApproveBusiness = async (data, token) => {
  try {
    // const response = await ManageOrg.post('companys/createBusinessRequset', data, { // เก่า
    const response = await ManageOrg.post('organization', data, { // ใหม่
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Insert Approve Business :', error.response)
    return error.response
  }
}
// API แก้ไขธุรกิจ เก่า
export const updateBusiness = async (data, token) => {
  try {
    const response = await ManageOrg.post('companys/editBusinessRequset', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error update Approve Business :', error.response)
    return error.response
  }
}

// API แก้ไขธุรกิจ ใหม่
export const updateBusinessNew = async (companyid, data, token) => {
  try {
    const response = await ManageOrg.patch(`organization/${companyid}`, data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error update Approve Business :', error.response)
    return error.response
  }
}
// Manage Business
export const fetchAllRequestApproveBusiness = async (data, token) => {
  try {
    const response = await ManageOrg.post('companys/getReqBusinessListByTokenAndTap', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get All Request Approve Business :', error.response)
  }
}
// get ข้อมูลจัดการธุรกิจ
export const fetchAllRequestManageBusiness = async (data, token) => {
  try {
    const response = await ManageOrg.post('organization/dashboard', data, { // ใหม่
    // const response = await ManageOrg.post('companys/getBusinessListByTokenAndTap', data, { // เก่า
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get All Request Approve Business :', error.response)
  }
}
// api get รายชื่อบริษัท
export const getAllSelectBusiness = async (data, token) => {
  try {
    const response = await ManageOrg.get('selector/organization?businessModelType=', { // ใหม่
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get All Request Approve Business :', error.response)
  }
}
// api สถานะ
export const getAllStatus = async (token) => {
  try {
    const response = await ManageOrg.get('selector/request/status', { // ใหม่
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get All Request Status :', error.response)
  }
}
// api ประเภทการลงทะเบียน
export const getAllRegisterType = async (token) => {
  try {
    const response = await ManageOrg.get('selector/register/status', { // ใหม่
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get All Request Register Type :', error.response)
  }
}
// api count หน้าอนุมัติ
export const getAllCountApproved = async (data, token) => {
  try {
    const response = await ManageOrg.post('organizeApprove/counter', data, { // ใหม่
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get All Request Approve Business :', error.response)
  }
}
// ข้อมูล select ในส่วนค้นหา
export const getSelectBusiness = async (data, token) => {
  try {
    const response = await ManageOrg.post('companys/selectBusinessList', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get Select business :', error.response)
  }
}
// ข้อมูลตัวเลือกประเภทธุรกิจ
export const getSelectBusinessNew = async (data, token) => {
  try {
    const response = await ManageOrg.get(`selector/businessType?businessType=${data.type}`)
    return response.data
  } catch (error) {
    console.warn('Error Get Select business :', error.response)
  }
}
// delete จัดการธุรกิจ เก่า
export const deleteBusinessById = async (data, token) => {
  try {
    const response = await ManageOrg.post('companys/deleteBusinessById', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Delete Business :', error.response)
  }
}
// delete จัดการธุรกิจ ใหม่
export const deleteBusinessByIdNew = async (data, token) => {
  try {
    const response = await ManageOrg.delete(`organization/${data.businessId}`, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Delete Business :', error.response)
  }
}

// Manage External Token
export const reqExternalToken = async (data, token) => {
  try {
    const response = await ManageOrg.post('externalApi/reqToken', data, {
      // const response = await ManageOrg.post('reqEmployee/insertReqEmployee', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Req External Token :', error.response)
    return error.response
  }
}
// API สร้าง Token(ร้องขอการใช้บริการ) **หน้าจัดการโทเคนภายนอก
export const insertExternalToken = async (data, token) => {
  try {
    const response = await ManageOrg.post('externalApi/createReqTokenExternal', data, {
      // const response = await ManageOrg.post('reqEmployee/insertReqEmployee', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Insert External Token :', error.response)
    return error.response
  }
}
// API ลบ Token ที่ใช้บริการ **หน้าจัดการโทเคนภายนอก
export const deleteExternalTokenById = async (data, token) => {
  try {
    const response = await ManageOrg.post('externalApi/deleteTokenById', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Delete Business :', error.response)
  }
}
// API แก้ไข Token ที่ใช้บริการ **หน้าจัดการโทเคนภายนอก
export const updateExternalToken = async (data, token) => {
  try {
    const response = await ManageOrg.post('externalApi/updateTokenDataById', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Uodate External Token :', error.response)
    return error.response
  }
}
// API get ข้อมูล Token ในส่วนของ tab บริการที่ใช้งาน(กด icon รูปตา)**หน้าจัดการโทเคนภายนอก
export const getDetailTokenById = async (token, data) => {
  try {
    const response = await ManageOrg.post('externalApi/getTokenDataById', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get Service By ID :', error.response)
  }
}
// API get ข้อมูล Token ในส่วนของ tab รายการร้องขอที่ใช้บริการ(กด icon รูปตา) **หน้าจัดการโทเคนภายนอก
export const getReqDetailTokenById = async (token, data) => {
  try {
    const response = await ManageOrg.post('externalApi/getReqTokenDataById', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get Service By ID :', error.response)
  }
}
// API Filter Data Token
export const fetchAllRequesManageExternalToken = async (data, token) => {
  try {
    const response = await ManageOrg.post('externalApi/getTokenAndReqTokenByTokenAndTap', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get All Request Approve External Token :', error.response)
  }
}
// API select ข้อมูลใน tab บริการที่ใช้งานและ tab รายการร้องขอที่ใช้บริการ **หน้าจัดการโทเคนภายนอก
export const getSelectApproveRequestToken = async (data, token) => {
  try {
    const response = await ManageOrg.post('externalApi/selectReqTokenByRole', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error get Select :', error.response)
  }
}

// Manage Transfer Role
export const getSelectCreateTransferRole = async (data, token) => {
  try {
    const response = await ManageOrg.post('authenTransfer/orgchartAndAuthenSelect', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error get select transfer role :', error.response)
  }
}
export const fetchAllTransferRole = async (data, token) => {
  try {
    const response = await ManageOrg.post('authenTransfer/authenList', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get All Transfer Role :', error.response)
  }
}
export const getSelectTransferRole = async (data, token) => {
  try {
    const response = await ManageOrg.post('authenTransfer/authenSelect', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get Select transfer role :', error.response)
  }
}

export const fetchAllRoleReceive = async (data, token) => {
  try {
    const response = await ManageOrg.post('authenTransfer/receiveAuthen', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get All Role Receive :', error.response)
  }
}

export const getSelectRoleReceive = async (token) => {
  try {
    const response = await ManageOrg.post('authenTransfer/receiveAuthenSelect', '', {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get Select role receive :', error.response)
  }
}

export const fetchAllTag = async (data, token) => {
  try {
    const response = await ManageOrg.post('authenTransfer/tagList', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get All Tag :', error.response)
  }
}

export const getSelectTag = async (token) => {
  try {
    const response = await ManageOrg.post('authenTransfer/tagSelect', '', {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get Select tag :', error.response)
  }
}

export const getOrgchartData = async (data, token) => {
  try {
    const response = await ManageOrg.post('authenTransfer/orgchartAndEmployeeSelect', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get Orgchart Data:', error.response)
  }
}

export const getSearchEmployee = async (data, token) => {
  try {
    const response = await ManageOrg.post('authenTransfer/searchEmployee', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get employee Data:', error.response)
  }
}

export const insertTag = async (data, token) => {
  try {
    const response = await ManageOrg.post('authenTransfer/createTag', data, {
      // const response = await ManageOrg.post('reqEmployee/insertReqEmployee', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Insert Tag :', error.response)
    return error.response
  }
}
export const updateTag = async (data, token) => {
  try {
    const response = await ManageOrg.post('authenTransfer/editTag', data, {
      // const response = await ManageOrg.post('reqEmployee/insertReqEmployee', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Update Tag :', error.response)
    return error.response
  }
}
export const fetchAllRequestAuthen = async (data, token) => {
  try {
    const response = await ManageOrg.post('authenTransfer/oldTrabsferList', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get all authen:', error.response)
  }
}

export const getSelectManageAuthen = async (token) => {
  try {
    const response = await ManageOrg.post('authenTransfer/oldTrabsferSelect', [], {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get Select transfer role :', error.response)
  }
}

export const insertTransferRole = async (data, token) => {
  try {
    const response = await ManageOrg.post('authenTransfer/createAuthenTransfer', data, {
      // const response = await ManageOrg.post('reqEmployee/insertReqEmployee', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Insert Tag :', error.response)
    return error.response
  }
}

export const deleteTag = async (data, token) => {
  try {
    // const response = await ManageOrg.post('roleManage/deleteGroupRoleMng', data, {
    const response = await ManageOrg.post('authenTransfer/deleteTag', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Delete:', error.response)
  }
}

// Manage Approve Transferrole
export const fetchAllRequestApproveTransferrole = async (data, token) => {
  try {
    const response = await ManageOrg.post('authenTransfer/reqTransferList', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get All Request Approve Transferrole :', error.response)
  }
}

export const getSelectApproveRequestTransferrole = async (data, token) => {
  try {
    const response = await ManageOrg.post('authenTransfer/reqTransferSelect', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error get select :', error.response)
  }
}
// ตารางห้าจัดการเครือข่ายและธุรกิจ
export const getDataTableManageCompany = async (data, token) => {
  try {
    const response = await ManageOrg.post('orgStructure/showStructure', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error get data :', error.response)
  }
}

// get ข้อมูลหน้าจัดการโครงสร้าง
export const getAllOrgchart = async (data, token) => {
  try {
    const response = await ManageOrg.post('orgchart', data, { // ใหม่
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Get All Orgchart :', error.response)
  }
}

// api เพิ่มระดับตำแหน่ง
export const addPositonsLevel = async (data, token) => {
  try {
    const response = await ManageOrg.post('position/positionlevel', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Add Position :', error.response)
  }
}

// api แก้ไขระดับตำแหน่ง.
export const editPositonsLevel = async (data, token) => {
  try {
    const response = await ManageOrg.patch('position/positionLvUpdate', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Edit Position :', error.response)
  }
}

// api sync อัปเดต user one
export const updateUserOneData = async (data, token) => {
  try {
    const response = await ManageOrg.put('/manageEmployee/updateUserOneData', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Edit Position :', error.response)
  }
}

// api ตารางระดับตำแหน่ง
export const getPositonsLevel = async (data, token) => {
  try {
    const response = await ManageOrg.post('position/positionLvOverview', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error get Position :', error.response)
  }
}
// api ตัวเลือกระดับตำแหน่ง
export const getSelectPositonsLevel = async (data) => {
  try {
    const response = await ManageOrg.post('selector/positionLv', data)
    return response.data
  } catch (error) {
    console.warn('Error get Select Position :', error.response)
  }
}

// api delete position level
export const delPositionLevel = async (data, token) => {
  try {
    const response = await ManageOrg.delete('position/positionLvDelete/' + data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    console.warn('Error Del Position:', error.response)
  }
}

// API group position
// Create Group Position
export const createPositionLevelGroup = async (data, token) => {
  try {
    const response = await ManageOrg.post('position/positionLevelGroup', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    return error.response
  }
}

export const updatePositionLevelGroupName = async (data, token) => {
  try {
    const response = await ManageOrg.put('position/positionLevelGroupName', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    return error.response.data
  }
}

// Delete Position Level In Group
export const deletePositionLevelInGroup = async (data, token) => {
  try {
    const response = await ManageOrg.post('position/deleteInPositionLevelGroup', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    return error.response.data
  }
}

export const deletePositionGroup = async (id, token) => {
  try {
    const response = await ManageOrg.delete(`position/positionLevelGroup/${id}`, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    return error.response.data
  }
}

export const createPositionLevelInGroup = async (data, token) => {
  try {
    const response = await ManageOrg.post('position/addInPositionLevelGroup', data, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    return error.response.data
  }
}

// Validate Duplicate In DB
export const validateDuplicateGroupName = async (data, token) => {
  try {
    const response = await ManageOrg.get(`position/validator/positionLevelGroupName?positionGroupName=${data}`, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    return error.response.data
  }
}

// Get Position Group Name Autocomplete
export const searchPositionLevelGroup = async (search, token) => {
  try {
    const response = await ManageOrg.get(`position/search/positionLevelGroup?search=${search}`, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    return error.response.data
  }
}

// Get Position Group List
export const getPositionLevelGroupList = async (page, size, search, token) => {
  try {
    let query = ''
    if (page > 0) {
      if (query === '') {
        query += `?page=${page}`
      } else {
        query += `&page=${page}`
      }
    }

    if (size > 0) {
      if (query === '') {
        query += `?limit=${size}`
      } else {
        query += `&limit=${size}`
      }
    }

    if (search && search !== '') {
      if (query === '') {
        query += `?search=${search}`
      } else {
        query += `&search=${search}`
      }
    }

    const response = await ManageOrg.get(`position/positionLevelGroup${query}`, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    return error.response.data
  }
}
// Validate Position is already in group ?
export const validateInPositionLevelGroup = async (data, token) => {
  try {
    let query = ''

    if (data.id && data.id !== '') {
      if (query === '') {
        query += `?id=${data.id}`
      } else {
        query += `&id=${data.id}`
      }
    }

    if (data.positionId && data.positionId !== '') {
      if (query === '') {
        query += `?positionId=${data.positionId}`
      } else {
        query += `&positionId=${data.positionId}`
      }
    }
    const response = await ManageOrg.get(`position/validator/inPositionLevelGroup${query}`, {
      headers: {
        Authorization: token
      }
    })
    return response.data
  } catch (error) {
    return error.response.data
  }
}

// End API Group position
